import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import LegalDocument from "@/components/legal/LegalDocument";
import AcceptableUseContent from "@/components/legal/AcceptableUseContent";

export const Route = createFileRoute("/acceptable-use")({
  component: AcceptableUsePolicy,
  head: () =>
    seoHead({
      title: "Acceptable Use Policy | Lutely",
      description: "What you may and may not upload, sell or do on Lutely.",
      canonicalPath: "/acceptable-use",
    }),
});

function AcceptableUsePolicy() {
  return (
    <LegalDocument title="Acceptable Use Policy">
      <AcceptableUseContent />
    </LegalDocument>
  );
}
